export const FIREBASE_FUNCTIONS_REGION = 'europe-west3'
